import React, { useEffect, useRef, useState } from "react";
import useDocViewerHook from "./useDocViewerHook";
import { useFullScreen } from "react-hooks-full-screen";
import { IconButton, Pagination } from "@mui/material";
import "./style.css";
import { Fullscreen } from "@mui/icons-material";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import DescriptionTwoToneIcon from "@mui/icons-material/DescriptionTwoTone";
import { getEmbedUrl } from "../../../apis/OcpwBoxDoc/OcpwBoxApi";

const DocViewerWidget = ({
  activeWidget,
  view,
  setMapSplit,
  mapSplit,
  dragging,
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [currDoc, setCurrDoc] = useState(0);
  const [showFullScreen, setShowFullScreen] = useState(false);
  const [screenPositionX, setScreenPositionX] = useState(0);
  const [screenPositionY, setScreenPositionY] = useState(0);

  const docIconRef = useRef(null);
  const mouseMoveEventHandler = useRef(null);
  const iFrameRef = useRef(null);
  const anchorElementRef = useRef(null);

  useFullScreen("doc__cont", showFullScreen);

  const payload: any[] = useDocViewerHook({
    view: view,
    OpenPanelCheck: { mapSplit: mapSplit, setMapSplit: setMapSplit },
  });

  useEffect(() => {
    if (activeWidget === "docViewer") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);

  useEffect(() => {
    setCurrDoc(0);
  }, [payload]);

  useEffect(() => {
    if (docIconRef.current) {
      view.ui.add(docIconRef.current, "manual");
    }
  }, []);

  useEffect(() => {
    if (activeWidget === "docViewer") {
      mouseMoveEventHandler.current = view.on("pointer-move", (e) => {
        setScreenPositionX(Math.round(e.x));
        setScreenPositionY(Math.round(e.y));
      });
    } else {
      if (mouseMoveEventHandler.current) {
        mouseMoveEventHandler.current.remove();
        mouseMoveEventHandler.current = "";
        setScreenPositionX(0);
        setScreenPositionY(0);
      }
    }
  }, [activeWidget]);

  useEffect(() => {
    if (
      iFrameRef.current &&
      anchorElementRef.current &&
      payload[currDoc]?.source === "box"
    ) {
      getEmbedUrl(iFrameRef.current && payload[currDoc]?.fileId).then((res) => {
        iFrameRef.current.src = res.data;
      });
    }
  }, [payload, currDoc]); //does not currently use payload change because it causes unwanted re-render

  // let style = { display: "initial" };
  // if (visible) {
  //   style.display = "initial";
  // } else {
  //   style.display = "none";
  // }

  const handlePaginationChange = (event, page) => {
    setCurrDoc(page - 1); // Pagination component is 1-based index, while the array is 0-based
  };

  return (
    <>
      <DescriptionTwoToneIcon
        ref={docIconRef}
        sx={
          screenPositionX && screenPositionY
            ? {
                display: "initial",
                padding: "8px",
                position: "absolute",
                top: `${screenPositionY + 5}px`,
                left: `${screenPositionX + 5}px`,
                width: "50px",
                height: "50px",
              }
            : { display: "none" }
        }
      />
      <div style={visible ? { display: "initial" } : { display: "none" }}>
        <div id="doc__cont" className="doc__cont">
          {payload.length ? (
            <>
              {payload[currDoc]?.displayType === "img" ? (
                <div
                  style={{
                    display: "flex",
                    height: "95%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ maxHeight: "95%", maxWidth: "95%" }}
                    alt="img"
                    src={payload[currDoc]?.url}
                  ></img>
                </div>
              ) : (
                <iframe
                  ref={iFrameRef}
                  className={
                    dragging ? "docFrameNonePointers" : "docFrameAllPointers"
                  }
                  title="OC Land Insights Document Viewer"
                  width="100%"
                  height="100%"
                  src={payload[currDoc]?.url}
                ></iframe>
              )}
              <div className="doc__navbar">
                <div className="doc__navbar__nav">
                  <Pagination
                    count={payload.length}
                    page={currDoc + 1}
                    onChange={handlePaginationChange}
                    color="primary"
                    sx={{
                      // Apply custom styles to the arrows and numbers
                      "& .MuiPaginationItem-root": {
                        color: "white", // White color for the page numbers
                        "&.Mui-selected": {
                          backgroundColor: "#fff", // White background for the active page number
                          color: "#000", // Black color for the active page number
                        },
                      },
                      "& .MuiPaginationItem-icon": {
                        color: "white", // White color for the arrows
                      },
                    }}
                  ></Pagination>
                </div>
                <div
                  style={{
                    marginLeft: "auto",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ marginLeft: "10px" }}>
                    <a
                      ref={anchorElementRef}
                      href={payload[currDoc]?.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {payload[currDoc]?.name}
                    </a>
                  </div>
                  <IconButton
                    style={{ marginLeft: "10px" }}
                    title={!showFullScreen ? "full-screen" : "exit full-screen"}
                    onClick={() => setShowFullScreen(!showFullScreen)}
                  >
                    {!showFullScreen ? (
                      <Fullscreen sx={{ color: "#ffffff" }} />
                    ) : (
                      <FullscreenExitIcon sx={{ color: "#ffffff" }} />
                    )}
                  </IconButton>
                </div>
              </div>
            </>
          ) : (
            <p className="doc__error">Select a document from the map to view</p>
          )}
        </div>
      </div>
    </>
  );
};

export default DocViewerWidget;
